interface TParams { name: string, values: (string | number)[]}

export interface TSelectSectionOptions {
    onChange(params: TParams): void;
    onInit?(params: TParams): void;
}

export class SelectSection {
    private readonly parent: HTMLElement;
    private readonly options: TSelectSectionOptions;
    private readonly svgWrapperEl: HTMLElement;
    private readonly fieldName: string;
    private readonly parentClass = 'select-section' as const;
    private readonly selectors = {
        area      : `${this.parentClass}__area`,
        areaGroup : `${this.parentClass}__area-group`,
        areaNum   : `${this.parentClass}__area-num`,
        svgWrapper: `${this.parentClass}__svg-wrapper`
    } as const;

    private readonly tagAttributes = {
        corpusValue : 'data-corpus-value',
        areaInactive: 'data-inactive',
        areaSelected: 'data-selected',
        fieldName   : 'data-field-name'
    } as const;

    constructor(parent: HTMLElement, options: TSelectSectionOptions) {
        if (!parent) {
            throw new Error(`Parent is ${parent}`);
        }

        this.parent = parent;
        this.options = options;
        this.fieldName = parent.getAttribute(this.tagAttributes.fieldName) as string;
        this.svgWrapperEl = parent.querySelector(`.${this.selectors.svgWrapper}`) as HTMLElement;

        if (typeof options.onInit === 'function') {
            options.onInit({
                name  : this.fieldName,
                values: this.getSelectedAreas()
            });
        }

        if (this.svgWrapperEl && typeof options.onChange === 'function') {
            this.svgWrapperEl.addEventListener('click', (event: HTMLElementEventMap['click']) => {
                const areaGroupEl = (event.target as HTMLElement).classList.contains(this.selectors.areaGroup) ?
                    (event.target as HTMLElement) :
                    (event.target as HTMLElement).parentElement;

                if (areaGroupEl?.closest(`.${this.selectors.areaGroup}`) &&
                    areaGroupEl.getAttribute(this.tagAttributes.areaInactive) === null) {
                    if (areaGroupEl.hasAttribute(this.tagAttributes.areaSelected)) {
                        areaGroupEl.removeAttribute(this.tagAttributes.areaSelected);
                    } else {
                        areaGroupEl.setAttribute(this.tagAttributes.areaSelected, '');
                    }

                    options.onChange({
                        name  : this.fieldName,
                        values: this.getSelectedAreas()
                    });
                }
            });
        }
    }

    reset = (): void => {
        if (!this.parent) {
            return;
        }

        [].slice
            .call(this.parent.querySelectorAll(`.${this.selectors.areaGroup}[${this.tagAttributes.areaSelected}]`))
            .forEach((el: HTMLElement) => {
                el.removeAttribute(this.tagAttributes.areaSelected);
            });

        this.options.onChange({
            name  : this.fieldName,
            values: this.getSelectedAreas()
        });
    };

    private getSelectedAreas = (): (string | number)[] => {
        return []
            .slice
            .call(this.svgWrapperEl
                .querySelectorAll(`.${this.selectors.areaGroup}[${this.tagAttributes.areaSelected}]`))
            .map((el: HTMLElement) => {
                return el.getAttribute(this.tagAttributes.corpusValue) as string;
            });
    };
}
